require('./bootstrap')

import Vue from 'vue'
import PortalVue from 'portal-vue'
import vuetify from '@/plugins/vuetify'
import { createInertiaApp } from '@inertiajs/inertia-vue'

Vue.use(PortalVue)
Vue.mixin({methods: {route}})


Vue.component('AppLayout',  () => import(/* webpackChunkName: "Layouts-AppLayout" */ './Layouts/AppLayout.vue'))

const files = require.context('./components', true, /[A-Z]\w+\.(vue)$/, 'lazy')
files.keys().map(key => {
  key = key.substring(2)
  Vue.component(key.split('/').pop().split('.')[0], () => import(`./components/${key}`))
})

createInertiaApp({
  resolve: name => import(/* webpackChunkName: "[request]" */ `./Pages/${name}`),
  setup({el, App, props, plugin}) {
    Vue.use(plugin)
    new Vue({
      vuetify,
      render: h => h(App, props),
    }).$mount(el)
  },
})
